import { render, staticRenderFns } from "./RedirectReturnMixin.vue?vue&type=template&id=63b63c8c&scoped=true"
import script from "./RedirectReturnMixin.vue?vue&type=script&lang=js"
export * from "./RedirectReturnMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b63c8c",
  null
  
)

export default component.exports